export enum Types {
	ATUALIZAR_MUNICIPIO_REQUEST = '@SGU/ATUALIZAR_MUNICIPIO_REQUEST',
	ATUALIZAR_MUNICIPIO_SUCCESS = '@SGU/ATUALIZAR_MUNICIPIO_SUCCESS',
	ATUALIZAR_MUNICIPIO_FAILURE = '@SGU/ATUALIZAR_MUNICIPIO_FAILURE',
	ATUALIZAR_MUNICIPIO_CLEAR = '@SGU/ATUALIZAR_MUNICIPIO_CLEAR',
}

export interface AtualizarMunicipio {
	status: number;
	data: null | MunicipioData;
}

interface MunicipioData {
	status: string;
	statusMensagem: string;
}

export interface AtualizarMunicipioRequest {
	id?: string | number;
	descricao: string;
	uf: string | number;
}
